import { AbstractControl, ValidationErrors } from '@angular/forms';

export function noLeadingTrailingSpacesValidator(control: AbstractControl): ValidationErrors | null {
  if (control.value && (control.value as string).trim() !== control.value) {
    return { hasSpaces: true };
  }
  return null;
}
